import { FC, useEffect, useMemo, useState } from "react"
import { Translated } from "../utils/translated"
import { Tabs, TabsProps } from "antd"
import { WifiOutlined } from "@ant-design/icons"
import { FlexCol } from "../components/commons-ts/common"
import { StationConfigSettings } from "./Settings/StationConfigSettings"
import { useHistory, useLocation } from "react-router-dom"
import { HeadHICConfigSettings } from "./Settings/HeadHICConfigSettings"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClipboard, faHardDrive, faSatellite } from "@fortawesome/free-solid-svg-icons"
import { DeviceHistorySettings } from "./Settings/DeviceHistorySettings"
import { WifiSettingsNative } from "./Settings/WifiSettingsNative"
import { ReactComponent as HicIcon } from "../svg/hic-icon.svg"
import { GNSSUbloxSettings } from "./Settings/GNSSUbloxSettings"
import { useSyncronizationContext } from "../providers/syncronizationProvider"
import { CENTRAL_CONTAINER_GAP } from "../utils/utils"

export enum EDeviceSettingsTabKey {
  DeviceHistory = "history",
  StationConfig = "station",
  HeadHICConfig = "headhic",
  WifiConfig = "wifi",
  GNSSConfig = "gnss",
}

export const SettingsDevice: FC = () => {
  const location = useLocation()
  const history = useHistory()
  const [selectedTabKey, setSelectedTabKey] = useState<EDeviceSettingsTabKey>(
    EDeviceSettingsTabKey.StationConfig,
  )
  const { isAdmin } = useSyncronizationContext()

  useEffect(() => {
    let parts = location.pathname.split("/")
    let arg = parts[parts.length - 1]
    if (arg === undefined) {
      return
    }
    switch (arg) {
      case EDeviceSettingsTabKey.StationConfig:
        setSelectedTabKey(EDeviceSettingsTabKey.StationConfig)
        break
      case EDeviceSettingsTabKey.HeadHICConfig:
        setSelectedTabKey(EDeviceSettingsTabKey.HeadHICConfig)
        break
      case EDeviceSettingsTabKey.WifiConfig:
        setSelectedTabKey(EDeviceSettingsTabKey.WifiConfig)
        break
      case EDeviceSettingsTabKey.DeviceHistory:
        setSelectedTabKey(EDeviceSettingsTabKey.DeviceHistory)
        break
      case EDeviceSettingsTabKey.GNSSConfig:
        setSelectedTabKey(EDeviceSettingsTabKey.GNSSConfig)
        break
    }
  }, [location.pathname])

  const memoTabItems = useMemo(() => {
    let items: TabsProps["items"] = [
      {
        key: EDeviceSettingsTabKey.DeviceHistory,
        label: (
          <span
            style={{
              marginLeft: 5,
            }}
          >
            <Translated keyEn="History" />
          </span>
        ),
        icon: <FontAwesomeIcon icon={faClipboard} />,
        children: <DeviceHistorySettings />,
      },
      {
        key: EDeviceSettingsTabKey.StationConfig,
        label: (
          <span
            style={{
              marginLeft: 5,
            }}
          >
            <Translated keyEn="Station" />
          </span>
        ),
        icon: <FontAwesomeIcon icon={faHardDrive} />,
        children: <StationConfigSettings />,
      },
      {
        key: EDeviceSettingsTabKey.HeadHICConfig,
        label: (
          <span
            style={{
              marginLeft: 5,
            }}
          >
            <Translated keyEn="Head HIC" />
          </span>
        ),
        icon: (
          <HicIcon
            className="hic-icon"
            width={24}
            style={{
              marginRight: -3,
              marginBottom: -9,
            }}
          />
        ),
        children: <HeadHICConfigSettings />,
      },
      {
        key: EDeviceSettingsTabKey.WifiConfig,
        label: (
          <span
            style={{
              marginLeft: 5,
            }}
          >
            <Translated keyEn="Wifi" />
          </span>
        ),
        icon: <WifiOutlined />,
        children: <WifiSettingsNative />,
      },
      {
        key: EDeviceSettingsTabKey.GNSSConfig,
        label: (
          <span
            style={{
              marginLeft: 5,
            }}
          >
            <Translated keyEn="GNSS" />
          </span>
        ),
        icon: <FontAwesomeIcon icon={faSatellite} />,
        children: <GNSSUbloxSettings />,
      },
    ]
    return items
  }, [isAdmin])

  return (
    <FlexCol
      style={{
        width: "80vw",
        maxWidth: "55rem", // MAX_WIDTH_CENTRAL_CONTAINER,
        margin: "auto",
        marginBottom: "2rem",
        alignItems: "center",
        gap: CENTRAL_CONTAINER_GAP,
      }}
    >
      <Tabs
        style={{
          width: "100%",
        }}
        destroyInactiveTabPane
        // centered
        animated
        tabBarGutter={20}
        activeKey={selectedTabKey}
        onChange={(key: string) => {
          setSelectedTabKey(key as EDeviceSettingsTabKey)
          history.push(`/settings/device/${key}`)
        }}
        size="large"
        items={memoTabItems}
      ></Tabs>
    </FlexCol>
  )
}
